import { Route } from '@angular/router';
import { DocumentsComponent } from 'app/components/documents/documents.component';

export const documentsRoute: Route = {
  path: 'documents',
  component: DocumentsComponent,
  data: { title: 'Документы' }
};
